module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "loading-simple-container"
  }, [_c('svg', {
    staticClass: "loading-draw-svg",
    attrs: {
      "viewBox": _vm.markViewBox,
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "loading-draw-path",
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": _vm.markPath
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-59a273b0!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/Loading/Loading.vue
// module id = 2136
// module chunks = 1